import { createApiRef } from '@backstage/core-plugin-api';
import {
  DamCapabilityJsonResponse,
  DamCapabilityProjectResponse,
} from './types';

/** @public */
export const DamCapabilityApiRef = createApiRef<DamCapabilityApi>({
  id: 'plugin.dam-capability.service',
});

/** @public */
export interface DamCapabilityApi {
  getCapabilityInfo(url: string): Promise<DamCapabilityJsonResponse>;
  getProjects(url: string): Promise<DamCapabilityProjectResponse>;
}
